import { useNavigate, useParams } from "react-router-dom";
import { ChatsPageInner } from "./chats.page";
import { useCentralStore } from "../../store/Central";
import { useJobStore } from "../../store/Jobs";
import { useMemo } from "react";
import { Tables } from "@/lib/supabase/supabaseTypesImport";

export const ClientChatsPage: React.FC = () => {
	const { clientId } = useParams();
	const navigate = useNavigate();
	const { organization, userId, clients } = useCentralStore((state) => ({
		organization: state.organization,
		userId: state.profile?.id,
		clients: Object.values(state.clientsLookup),
	}));
	const { shareFile, unshareFile, acceptJobRequest, denyJobRequest } =
		useJobStore((state) => ({
			shareFile: state.shareFile,
			unshareFile: state.unshareFile,
			acceptJobRequest: state.acceptJobRequest,
			denyJobRequest: state.denyJobRequest,
		}));
	if (!organization?.id || !userId) {
		return <div></div>;
	}

	const customerOrganizationId = useMemo(() => {
		const client = clients.find((client) => client.id === clientId);
		return client?.connected_organization_id ?? undefined;
	}, [clientId, clients]);

	const onSelectChannel = (channel: Tables<"message_channels">) => {
		if (channel.id) {
			navigate(`/client/${clientId}/chats/${channel.id}`);
		}
	};

	return (
		<div className="h-full flex">
			<ChatsPageInner
				organizationId={organization.id}
				onShareFile={shareFile}
				onUnshareFile={unshareFile}
				onAcceptJobRequest={acceptJobRequest}
				onDenyJobRequest={denyJobRequest}
				userId={userId}
				customerOrganizationId={customerOrganizationId}
				clientOrganizationIds={[customerOrganizationId ?? ""]}
				onSelectChannel={onSelectChannel}
			/>
		</div>
	);
};
